import { getUtilityClasses } from "./styles";
export const fieldContainerClasses = getUtilityClasses("FieldContainer", [
    "root",
    "outlined",
    "standard",
    "focused",
    "disabled",
    "notchedOutline",
]);
